import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface Props {
  openConfirm: boolean;
  setOpenConfirm: (open: boolean) => void;
  type: string;
  index: number;
  deleteGameHandler: (index: number) => void;
  isLoading: boolean;
}

const DeleteDialog = (props: Props) => {
  return (
    <Dialog
      open={props.openConfirm}
      onClose={() => props.setOpenConfirm(false)}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        Are you sure you want to delete {props.type}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          All cards with this {props.type} would effected.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setOpenConfirm(false)}>Cancel</Button>
        <Button
          onClick={() => {
            props.deleteGameHandler(props.index);
            props.setOpenConfirm(false);
          }}
          autoFocus
          disabled={props.isLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteDialog;
